import { jsxs as $e, jsx as de } from "react/jsx-runtime";
import { V as _n, E as mn } from "../index-DiWzAyMV.js";
import { c as Ke } from "../clsx-OuTLNxxd.js";
import { g as yn } from "../_commonjsHelpers-DaMA6jEr.js";
import * as q from "react";
import { useRef as we, useEffect as xe, useCallback as te, useMemo as ft, cloneElement as In, Component as En } from "react";
import { r as pt } from "../index-CV3qP_xA.js";
import { B as bn } from "../Button-DIvSLTPg.js";
import { L as wn } from "../Label-C6Cio33A.js";
import '../Dropdown.css';function se(t, n) {
  if (t == null) return {};
  var o = {};
  for (var r in t) if ({}.hasOwnProperty.call(t, r)) {
    if (n.indexOf(r) !== -1) continue;
    o[r] = t[r];
  }
  return o;
}
function B() {
  return B = Object.assign ? Object.assign.bind() : function(t) {
    for (var n = 1; n < arguments.length; n++) {
      var o = arguments[n];
      for (var r in o) ({}).hasOwnProperty.call(o, r) && (t[r] = o[r]);
    }
    return t;
  }, B.apply(null, arguments);
}
function Ye(t, n) {
  return Ye = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, r) {
    return o.__proto__ = r, o;
  }, Ye(t, n);
}
function xn(t, n) {
  t.prototype = Object.create(n.prototype), t.prototype.constructor = t, Ye(t, n);
}
var ze = { exports: {} }, Oe = { exports: {} }, F = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gt;
function On() {
  if (gt) return F;
  gt = 1;
  var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, o = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, e = t ? Symbol.for("react.profiler") : 60114, u = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, v = t ? Symbol.for("react.async_mode") : 60111, d = t ? Symbol.for("react.concurrent_mode") : 60111, I = t ? Symbol.for("react.forward_ref") : 60112, E = t ? Symbol.for("react.suspense") : 60113, O = t ? Symbol.for("react.suspense_list") : 60120, S = t ? Symbol.for("react.memo") : 60115, M = t ? Symbol.for("react.lazy") : 60116, N = t ? Symbol.for("react.block") : 60121, K = t ? Symbol.for("react.fundamental") : 60117, L = t ? Symbol.for("react.responder") : 60118, s = t ? Symbol.for("react.scope") : 60119;
  function a(l) {
    if (typeof l == "object" && l !== null) {
      var b = l.$$typeof;
      switch (b) {
        case n:
          switch (l = l.type, l) {
            case v:
            case d:
            case r:
            case e:
            case i:
            case E:
              return l;
            default:
              switch (l = l && l.$$typeof, l) {
                case c:
                case I:
                case M:
                case S:
                case u:
                  return l;
                default:
                  return b;
              }
          }
        case o:
          return b;
      }
    }
  }
  function f(l) {
    return a(l) === d;
  }
  return F.AsyncMode = v, F.ConcurrentMode = d, F.ContextConsumer = c, F.ContextProvider = u, F.Element = n, F.ForwardRef = I, F.Fragment = r, F.Lazy = M, F.Memo = S, F.Portal = o, F.Profiler = e, F.StrictMode = i, F.Suspense = E, F.isAsyncMode = function(l) {
    return f(l) || a(l) === v;
  }, F.isConcurrentMode = f, F.isContextConsumer = function(l) {
    return a(l) === c;
  }, F.isContextProvider = function(l) {
    return a(l) === u;
  }, F.isElement = function(l) {
    return typeof l == "object" && l !== null && l.$$typeof === n;
  }, F.isForwardRef = function(l) {
    return a(l) === I;
  }, F.isFragment = function(l) {
    return a(l) === r;
  }, F.isLazy = function(l) {
    return a(l) === M;
  }, F.isMemo = function(l) {
    return a(l) === S;
  }, F.isPortal = function(l) {
    return a(l) === o;
  }, F.isProfiler = function(l) {
    return a(l) === e;
  }, F.isStrictMode = function(l) {
    return a(l) === i;
  }, F.isSuspense = function(l) {
    return a(l) === E;
  }, F.isValidElementType = function(l) {
    return typeof l == "string" || typeof l == "function" || l === r || l === d || l === e || l === i || l === E || l === O || typeof l == "object" && l !== null && (l.$$typeof === M || l.$$typeof === S || l.$$typeof === u || l.$$typeof === c || l.$$typeof === I || l.$$typeof === K || l.$$typeof === L || l.$$typeof === s || l.$$typeof === N);
  }, F.typeOf = a, F;
}
var U = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ht;
function Dn() {
  return ht || (ht = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, o = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, e = t ? Symbol.for("react.profiler") : 60114, u = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, v = t ? Symbol.for("react.async_mode") : 60111, d = t ? Symbol.for("react.concurrent_mode") : 60111, I = t ? Symbol.for("react.forward_ref") : 60112, E = t ? Symbol.for("react.suspense") : 60113, O = t ? Symbol.for("react.suspense_list") : 60120, S = t ? Symbol.for("react.memo") : 60115, M = t ? Symbol.for("react.lazy") : 60116, N = t ? Symbol.for("react.block") : 60121, K = t ? Symbol.for("react.fundamental") : 60117, L = t ? Symbol.for("react.responder") : 60118, s = t ? Symbol.for("react.scope") : 60119;
    function a(m) {
      return typeof m == "string" || typeof m == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      m === r || m === d || m === e || m === i || m === E || m === O || typeof m == "object" && m !== null && (m.$$typeof === M || m.$$typeof === S || m.$$typeof === u || m.$$typeof === c || m.$$typeof === I || m.$$typeof === K || m.$$typeof === L || m.$$typeof === s || m.$$typeof === N);
    }
    function f(m) {
      if (typeof m == "object" && m !== null) {
        var G = m.$$typeof;
        switch (G) {
          case n:
            var oe = m.type;
            switch (oe) {
              case v:
              case d:
              case r:
              case e:
              case i:
              case E:
                return oe;
              default:
                var ue = oe && oe.$$typeof;
                switch (ue) {
                  case c:
                  case I:
                  case M:
                  case S:
                  case u:
                    return ue;
                  default:
                    return G;
                }
            }
          case o:
            return G;
        }
      }
    }
    var l = v, b = d, k = c, C = u, j = n, H = I, $ = r, W = M, z = S, T = o, Z = e, X = i, ee = E, ie = !1;
    function ae(m) {
      return ie || (ie = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), g(m) || f(m) === v;
    }
    function g(m) {
      return f(m) === d;
    }
    function p(m) {
      return f(m) === c;
    }
    function y(m) {
      return f(m) === u;
    }
    function _(m) {
      return typeof m == "object" && m !== null && m.$$typeof === n;
    }
    function w(m) {
      return f(m) === I;
    }
    function R(m) {
      return f(m) === r;
    }
    function D(m) {
      return f(m) === M;
    }
    function x(m) {
      return f(m) === S;
    }
    function P(m) {
      return f(m) === o;
    }
    function A(m) {
      return f(m) === e;
    }
    function V(m) {
      return f(m) === i;
    }
    function Y(m) {
      return f(m) === E;
    }
    U.AsyncMode = l, U.ConcurrentMode = b, U.ContextConsumer = k, U.ContextProvider = C, U.Element = j, U.ForwardRef = H, U.Fragment = $, U.Lazy = W, U.Memo = z, U.Portal = T, U.Profiler = Z, U.StrictMode = X, U.Suspense = ee, U.isAsyncMode = ae, U.isConcurrentMode = g, U.isContextConsumer = p, U.isContextProvider = y, U.isElement = _, U.isForwardRef = w, U.isFragment = R, U.isLazy = D, U.isMemo = x, U.isPortal = P, U.isProfiler = A, U.isStrictMode = V, U.isSuspense = Y, U.isValidElementType = a, U.typeOf = f;
  }()), U;
}
var vt;
function Rt() {
  return vt || (vt = 1, process.env.NODE_ENV === "production" ? Oe.exports = On() : Oe.exports = Dn()), Oe.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Le, _t;
function Sn() {
  if (_t) return Le;
  _t = 1;
  var t = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, o = Object.prototype.propertyIsEnumerable;
  function r(e) {
    if (e == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var e = new String("abc");
      if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5")
        return !1;
      for (var u = {}, c = 0; c < 10; c++)
        u["_" + String.fromCharCode(c)] = c;
      var v = Object.getOwnPropertyNames(u).map(function(I) {
        return u[I];
      });
      if (v.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(I) {
        d[I] = I;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Le = i() ? Object.assign : function(e, u) {
    for (var c, v = r(e), d, I = 1; I < arguments.length; I++) {
      c = Object(arguments[I]);
      for (var E in c)
        n.call(c, E) && (v[E] = c[E]);
      if (t) {
        d = t(c);
        for (var O = 0; O < d.length; O++)
          o.call(c, d[O]) && (v[d[O]] = c[d[O]]);
      }
    }
    return v;
  }, Le;
}
var je, mt;
function Ze() {
  if (mt) return je;
  mt = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return je = t, je;
}
var We, yt;
function Pt() {
  return yt || (yt = 1, We = Function.call.bind(Object.prototype.hasOwnProperty)), We;
}
var Fe, It;
function Cn() {
  if (It) return Fe;
  It = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var n = Ze(), o = {}, r = Pt();
    t = function(e) {
      var u = "Warning: " + e;
      typeof console < "u" && console.error(u);
      try {
        throw new Error(u);
      } catch {
      }
    };
  }
  function i(e, u, c, v, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var I in e)
        if (r(e, I)) {
          var E;
          try {
            if (typeof e[I] != "function") {
              var O = Error(
                (v || "React class") + ": " + c + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw O.name = "Invariant Violation", O;
            }
            E = e[I](u, I, v, c, null, n);
          } catch (M) {
            E = M;
          }
          if (E && !(E instanceof Error) && t(
            (v || "React class") + ": type specification of " + c + " `" + I + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof E + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), E instanceof Error && !(E.message in o)) {
            o[E.message] = !0;
            var S = d ? d() : "";
            t(
              "Failed " + c + " type: " + E.message + (S ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (o = {});
  }, Fe = i, Fe;
}
var Ue, Et;
function Tn() {
  if (Et) return Ue;
  Et = 1;
  var t = Rt(), n = Sn(), o = Ze(), r = Pt(), i = Cn(), e = function() {
  };
  process.env.NODE_ENV !== "production" && (e = function(c) {
    var v = "Warning: " + c;
    typeof console < "u" && console.error(v);
    try {
      throw new Error(v);
    } catch {
    }
  });
  function u() {
    return null;
  }
  return Ue = function(c, v) {
    var d = typeof Symbol == "function" && Symbol.iterator, I = "@@iterator";
    function E(g) {
      var p = g && (d && g[d] || g[I]);
      if (typeof p == "function")
        return p;
    }
    var O = "<<anonymous>>", S = {
      array: L("array"),
      bigint: L("bigint"),
      bool: L("boolean"),
      func: L("function"),
      number: L("number"),
      object: L("object"),
      string: L("string"),
      symbol: L("symbol"),
      any: s(),
      arrayOf: a,
      element: f(),
      elementType: l(),
      instanceOf: b,
      node: H(),
      objectOf: C,
      oneOf: k,
      oneOfType: j,
      shape: W,
      exact: z
    };
    function M(g, p) {
      return g === p ? g !== 0 || 1 / g === 1 / p : g !== g && p !== p;
    }
    function N(g, p) {
      this.message = g, this.data = p && typeof p == "object" ? p : {}, this.stack = "";
    }
    N.prototype = Error.prototype;
    function K(g) {
      if (process.env.NODE_ENV !== "production")
        var p = {}, y = 0;
      function _(R, D, x, P, A, V, Y) {
        if (P = P || O, V = V || x, Y !== o) {
          if (v) {
            var m = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw m.name = "Invariant Violation", m;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var G = P + ":" + x;
            !p[G] && // Avoid spamming the console because they are often not actionable except for lib authors
            y < 3 && (e(
              "You are manually calling a React.PropTypes validation function for the `" + V + "` prop on `" + P + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), p[G] = !0, y++);
          }
        }
        return D[x] == null ? R ? D[x] === null ? new N("The " + A + " `" + V + "` is marked as required " + ("in `" + P + "`, but its value is `null`.")) : new N("The " + A + " `" + V + "` is marked as required in " + ("`" + P + "`, but its value is `undefined`.")) : null : g(D, x, P, A, V);
      }
      var w = _.bind(null, !1);
      return w.isRequired = _.bind(null, !0), w;
    }
    function L(g) {
      function p(y, _, w, R, D, x) {
        var P = y[_], A = X(P);
        if (A !== g) {
          var V = ee(P);
          return new N(
            "Invalid " + R + " `" + D + "` of type " + ("`" + V + "` supplied to `" + w + "`, expected ") + ("`" + g + "`."),
            { expectedType: g }
          );
        }
        return null;
      }
      return K(p);
    }
    function s() {
      return K(u);
    }
    function a(g) {
      function p(y, _, w, R, D) {
        if (typeof g != "function")
          return new N("Property `" + D + "` of component `" + w + "` has invalid PropType notation inside arrayOf.");
        var x = y[_];
        if (!Array.isArray(x)) {
          var P = X(x);
          return new N("Invalid " + R + " `" + D + "` of type " + ("`" + P + "` supplied to `" + w + "`, expected an array."));
        }
        for (var A = 0; A < x.length; A++) {
          var V = g(x, A, w, R, D + "[" + A + "]", o);
          if (V instanceof Error)
            return V;
        }
        return null;
      }
      return K(p);
    }
    function f() {
      function g(p, y, _, w, R) {
        var D = p[y];
        if (!c(D)) {
          var x = X(D);
          return new N("Invalid " + w + " `" + R + "` of type " + ("`" + x + "` supplied to `" + _ + "`, expected a single ReactElement."));
        }
        return null;
      }
      return K(g);
    }
    function l() {
      function g(p, y, _, w, R) {
        var D = p[y];
        if (!t.isValidElementType(D)) {
          var x = X(D);
          return new N("Invalid " + w + " `" + R + "` of type " + ("`" + x + "` supplied to `" + _ + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return K(g);
    }
    function b(g) {
      function p(y, _, w, R, D) {
        if (!(y[_] instanceof g)) {
          var x = g.name || O, P = ae(y[_]);
          return new N("Invalid " + R + " `" + D + "` of type " + ("`" + P + "` supplied to `" + w + "`, expected ") + ("instance of `" + x + "`."));
        }
        return null;
      }
      return K(p);
    }
    function k(g) {
      if (!Array.isArray(g))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? e(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : e("Invalid argument supplied to oneOf, expected an array.")), u;
      function p(y, _, w, R, D) {
        for (var x = y[_], P = 0; P < g.length; P++)
          if (M(x, g[P]))
            return null;
        var A = JSON.stringify(g, function(Y, m) {
          var G = ee(m);
          return G === "symbol" ? String(m) : m;
        });
        return new N("Invalid " + R + " `" + D + "` of value `" + String(x) + "` " + ("supplied to `" + w + "`, expected one of " + A + "."));
      }
      return K(p);
    }
    function C(g) {
      function p(y, _, w, R, D) {
        if (typeof g != "function")
          return new N("Property `" + D + "` of component `" + w + "` has invalid PropType notation inside objectOf.");
        var x = y[_], P = X(x);
        if (P !== "object")
          return new N("Invalid " + R + " `" + D + "` of type " + ("`" + P + "` supplied to `" + w + "`, expected an object."));
        for (var A in x)
          if (r(x, A)) {
            var V = g(x, A, w, R, D + "." + A, o);
            if (V instanceof Error)
              return V;
          }
        return null;
      }
      return K(p);
    }
    function j(g) {
      if (!Array.isArray(g))
        return process.env.NODE_ENV !== "production" && e("Invalid argument supplied to oneOfType, expected an instance of array."), u;
      for (var p = 0; p < g.length; p++) {
        var y = g[p];
        if (typeof y != "function")
          return e(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ie(y) + " at index " + p + "."
          ), u;
      }
      function _(w, R, D, x, P) {
        for (var A = [], V = 0; V < g.length; V++) {
          var Y = g[V], m = Y(w, R, D, x, P, o);
          if (m == null)
            return null;
          m.data && r(m.data, "expectedType") && A.push(m.data.expectedType);
        }
        var G = A.length > 0 ? ", expected one of type [" + A.join(", ") + "]" : "";
        return new N("Invalid " + x + " `" + P + "` supplied to " + ("`" + D + "`" + G + "."));
      }
      return K(_);
    }
    function H() {
      function g(p, y, _, w, R) {
        return T(p[y]) ? null : new N("Invalid " + w + " `" + R + "` supplied to " + ("`" + _ + "`, expected a ReactNode."));
      }
      return K(g);
    }
    function $(g, p, y, _, w) {
      return new N(
        (g || "React class") + ": " + p + " type `" + y + "." + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + w + "`."
      );
    }
    function W(g) {
      function p(y, _, w, R, D) {
        var x = y[_], P = X(x);
        if (P !== "object")
          return new N("Invalid " + R + " `" + D + "` of type `" + P + "` " + ("supplied to `" + w + "`, expected `object`."));
        for (var A in g) {
          var V = g[A];
          if (typeof V != "function")
            return $(w, R, D, A, ee(V));
          var Y = V(x, A, w, R, D + "." + A, o);
          if (Y)
            return Y;
        }
        return null;
      }
      return K(p);
    }
    function z(g) {
      function p(y, _, w, R, D) {
        var x = y[_], P = X(x);
        if (P !== "object")
          return new N("Invalid " + R + " `" + D + "` of type `" + P + "` " + ("supplied to `" + w + "`, expected `object`."));
        var A = n({}, y[_], g);
        for (var V in A) {
          var Y = g[V];
          if (r(g, V) && typeof Y != "function")
            return $(w, R, D, V, ee(Y));
          if (!Y)
            return new N(
              "Invalid " + R + " `" + D + "` key `" + V + "` supplied to `" + w + "`.\nBad object: " + JSON.stringify(y[_], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(g), null, "  ")
            );
          var m = Y(x, V, w, R, D + "." + V, o);
          if (m)
            return m;
        }
        return null;
      }
      return K(p);
    }
    function T(g) {
      switch (typeof g) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !g;
        case "object":
          if (Array.isArray(g))
            return g.every(T);
          if (g === null || c(g))
            return !0;
          var p = E(g);
          if (p) {
            var y = p.call(g), _;
            if (p !== g.entries) {
              for (; !(_ = y.next()).done; )
                if (!T(_.value))
                  return !1;
            } else
              for (; !(_ = y.next()).done; ) {
                var w = _.value;
                if (w && !T(w[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Z(g, p) {
      return g === "symbol" ? !0 : p ? p["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && p instanceof Symbol : !1;
    }
    function X(g) {
      var p = typeof g;
      return Array.isArray(g) ? "array" : g instanceof RegExp ? "object" : Z(p, g) ? "symbol" : p;
    }
    function ee(g) {
      if (typeof g > "u" || g === null)
        return "" + g;
      var p = X(g);
      if (p === "object") {
        if (g instanceof Date)
          return "date";
        if (g instanceof RegExp)
          return "regexp";
      }
      return p;
    }
    function ie(g) {
      var p = ee(g);
      switch (p) {
        case "array":
        case "object":
          return "an " + p;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + p;
        default:
          return p;
      }
    }
    function ae(g) {
      return !g.constructor || !g.constructor.name ? O : g.constructor.name;
    }
    return S.checkPropTypes = i, S.resetWarningCache = i.resetWarningCache, S.PropTypes = S, S;
  }, Ue;
}
var qe, bt;
function Nn() {
  if (bt) return qe;
  bt = 1;
  var t = Ze();
  function n() {
  }
  function o() {
  }
  return o.resetWarningCache = n, qe = function() {
    function r(u, c, v, d, I, E) {
      if (E !== t) {
        var O = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw O.name = "Invariant Violation", O;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var e = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: o,
      resetWarningCache: n
    };
    return e.PropTypes = e, e;
  }, qe;
}
if (process.env.NODE_ENV !== "production") {
  var Rn = Rt(), Pn = !0;
  ze.exports = Tn()(Rn.isElement, Pn);
} else
  ze.exports = Nn()();
var Mn = ze.exports;
const h = /* @__PURE__ */ yn(Mn), wt = (t) => typeof t == "object" && t != null && t.nodeType === 1, xt = (t, n) => (!n || t !== "hidden") && t !== "visible" && t !== "clip", De = (t, n) => {
  if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
    const o = getComputedStyle(t, null);
    return xt(o.overflowY, n) || xt(o.overflowX, n) || ((r) => {
      const i = ((e) => {
        if (!e.ownerDocument || !e.ownerDocument.defaultView) return null;
        try {
          return e.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(r);
      return !!i && (i.clientHeight < r.scrollHeight || i.clientWidth < r.scrollWidth);
    })(t);
  }
  return !1;
}, Se = (t, n, o, r, i, e, u, c) => e < t && u > n || e > t && u < n ? 0 : e <= t && c <= o || u >= n && c >= o ? e - t - r : u > n && c < o || e < t && c > o ? u - n + i : 0, Vn = (t) => {
  const n = t.parentElement;
  return n ?? (t.getRootNode().host || null);
}, kn = (t, n) => {
  var o, r, i, e;
  if (typeof document > "u") return [];
  const { inline: u, boundary: c, skipOverflowHiddenElements: v } = n, d = typeof c == "function" ? c : (z) => z !== c;
  if (!wt(t)) throw new TypeError("Invalid target");
  const I = document.scrollingElement || document.documentElement, E = [];
  let O = t;
  for (; wt(O) && d(O); ) {
    if (O = Vn(O), O === I) {
      E.push(O);
      break;
    }
    O != null && O === document.body && De(O) && !De(document.documentElement) || O != null && De(O, v) && E.push(O);
  }
  const S = (r = (o = window.visualViewport) == null ? void 0 : o.width) != null ? r : innerWidth, M = (e = (i = window.visualViewport) == null ? void 0 : i.height) != null ? e : innerHeight, { scrollX: N, scrollY: K } = window, { height: L, width: s, top: a, right: f, bottom: l, left: b } = t.getBoundingClientRect(), { top: k, right: C, left: j } = ((z) => {
    const T = window.getComputedStyle(z);
    return { top: parseFloat(T.scrollMarginTop) || 0, right: parseFloat(T.scrollMarginRight) || 0, bottom: parseFloat(T.scrollMarginBottom) || 0, left: parseFloat(T.scrollMarginLeft) || 0 };
  })(t);
  let H = a - k, $ = u === "center" ? b + s / 2 - j + C : u === "end" ? f + C : b - j;
  const W = [];
  for (let z = 0; z < E.length; z++) {
    const T = E[z], { height: Z, width: X, top: ee, right: ie, bottom: ae, left: g } = T.getBoundingClientRect();
    if (a >= 0 && b >= 0 && l <= M && f <= S && (T === I && !De(T) || a >= ee && l <= ae && b >= g && f <= ie)) return W;
    const p = getComputedStyle(T), y = parseInt(p.borderLeftWidth, 10), _ = parseInt(p.borderTopWidth, 10), w = parseInt(p.borderRightWidth, 10), R = parseInt(p.borderBottomWidth, 10);
    let D = 0, x = 0;
    const P = "offsetWidth" in T ? T.offsetWidth - T.clientWidth - y - w : 0, A = "offsetHeight" in T ? T.offsetHeight - T.clientHeight - _ - R : 0, V = "offsetWidth" in T ? T.offsetWidth === 0 ? 0 : X / T.offsetWidth : 0, Y = "offsetHeight" in T ? T.offsetHeight === 0 ? 0 : Z / T.offsetHeight : 0;
    if (I === T) D = Se(K, K + M, M, _, R, K + H, K + H + L, L), x = u === "start" ? $ : u === "center" ? $ - S / 2 : u === "end" ? $ - S : Se(N, N + S, S, y, w, N + $, N + $ + s, s), D = Math.max(0, D + K), x = Math.max(0, x + N);
    else {
      D = Se(ee, ae, Z, _, R + A, H, H + L, L), x = u === "start" ? $ - g - y : u === "center" ? $ - (g + X / 2) + P / 2 : u === "end" ? $ - ie + w + P : Se(g, ie, X, y, w + P, $, $ + s, s);
      const { scrollLeft: m, scrollTop: G } = T;
      D = Y === 0 ? 0 : Math.max(0, Math.min(G + D / Y, T.scrollHeight - Z / Y + A)), x = V === 0 ? 0 : Math.max(0, Math.min(m + x / V, T.scrollWidth - X / V + P)), H += G - D, $ += m - x;
    }
    W.push({ el: T, top: D, left: x });
  }
  return W;
};
var Mt = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, Vt = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, kt = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, Te = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, Ne = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, Ht = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, At = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, Bt = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, $t = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, Kt = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, Lt = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, jt = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, Wt = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, Ge = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, Ft = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, Ut = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, qt = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, Hn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blurButton: Ft,
  blurInput: Lt,
  changeInput: jt,
  clickButton: Ge,
  clickItem: Kt,
  controlledPropUpdatedSelectedItem: Ut,
  itemMouseEnter: kt,
  keyDownArrowDown: Ne,
  keyDownArrowUp: Te,
  keyDownEnd: $t,
  keyDownEnter: At,
  keyDownEscape: Ht,
  keyDownHome: Bt,
  keyDownSpaceButton: Wt,
  mouseUp: Vt,
  touchEnd: qt,
  unknown: Mt
}), An = 0;
function Yt() {
  return String(An++);
}
var Bn = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", zt = Bn ? q.useLayoutEffect : q.useEffect;
function Gt(t) {
  var n = q.useRef(t);
  return zt(function() {
    n.current = t;
  }, [t]), n;
}
function me() {
  for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++)
    n[o] = arguments[o];
  return function(r) {
    n.forEach(function(i) {
      typeof i == "function" ? i(r) : i && (i.current = r);
    });
  };
}
function J() {
  for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++)
    n[o] = arguments[o];
  return function(r) {
    for (var i = arguments.length, e = new Array(i > 1 ? i - 1 : 0), u = 1; u < i; u++)
      e[u - 1] = arguments[u];
    return n.some(function(c) {
      return c && c.apply(void 0, [r].concat(e)), r.preventDownshiftDefault || r.hasOwnProperty("nativeEvent") && r.nativeEvent.preventDownshiftDefault;
    });
  };
}
function Be(t, n) {
  var o;
  function r() {
    o && clearTimeout(o);
  }
  function i() {
    for (var e = arguments.length, u = new Array(e), c = 0; c < e; c++)
      u[c] = arguments[c];
    r(), o = setTimeout(function() {
      o = null, t.apply(void 0, u);
    }, n);
  }
  return i.cancel = r, i;
}
var $n = Be(function(t) {
  Xt(t).textContent = "";
}, 500);
function Xt(t) {
  var n = t.getElementById("a11y-status-message");
  return n || (n = t.createElement("div"), n.setAttribute("id", "a11y-status-message"), n.setAttribute("role", "status"), n.setAttribute("aria-live", "polite"), n.setAttribute("aria-relevant", "additions text"), Object.assign(n.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), t.body.appendChild(n), n);
}
function Jt(t, n) {
  if (!(!t || !n)) {
    var o = Xt(n);
    o.textContent = t, $n(n);
  }
}
function Kn(t) {
  var n = t == null ? void 0 : t.getElementById("a11y-status-message");
  n && n.remove();
}
function Q() {
}
var Zt = Q;
process.env.NODE_ENV !== "production" && (Zt = function(n, o, r) {
  h.checkPropTypes(r, n, "prop", o.name);
});
function Me(t, n) {
  if (!n)
    return t;
  var o = Object.keys(t);
  return o.reduce(function(r, i) {
    return n[i] !== void 0 && (r[i] = n[i]), r;
  }, B({}, t));
}
function Qt(t, n) {
  if (t) {
    var o = kn(t, {
      boundary: n
    });
    o.forEach(function(r) {
      var i = r.el, e = r.top, u = r.left;
      i.scrollTop = e, i.scrollLeft = u;
    });
  }
}
function Xe(t) {
  var n = t.key, o = t.keyCode;
  return o >= 37 && o <= 40 && !n.startsWith("Arrow") ? "Arrow" + n : n;
}
function he(t, n, o, r, i) {
  i === void 0 && (i = !1);
  var e = o.length;
  if (n) {
    for (var u = t; u >= 0; u--)
      if (!r(o[u], u))
        return u;
  } else
    for (var c = t; c < e; c++)
      if (!r(o[c], c))
        return c;
  return i ? he(n ? e - 1 : 0, n, o, r) : -1;
}
function fe(t, n, o, r, i) {
  i === void 0 && (i = !1);
  var e = o.length;
  if (e === 0)
    return -1;
  var u = e - 1;
  (typeof t != "number" || t < 0 || t > u) && (t = n > 0 ? -1 : u + 1);
  var c = t + n;
  c < 0 ? c = i ? u : 0 : c > u && (c = i ? 0 : u);
  var v = he(c, n < 0, o, r, i);
  return v === -1 ? t >= e ? -1 : t : v;
}
var Qe = Q;
process.env.NODE_ENV !== "production" && (Qe = function(n, o, r) {
  var i = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(n).forEach(function(e) {
    o[e] !== void 0 && r[e] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + e + '" to be uncontrolled. ' + i) : o[e] === void 0 && r[e] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + e + '" to be controlled. ' + i);
  });
});
function Ve(t, n, o, r) {
  return r === void 0 && (r = !0), !!o && n.some(function(i) {
    return i && (Ot(i, t, o) || r && Ot(i, o.document.activeElement, o));
  });
}
function Ot(t, n, o) {
  var r = t === n || n instanceof o.Node && t.contains(n);
  return r;
}
function Dt(t) {
  return typeof t == "function" ? t : Q;
}
function Ln(t) {
  var n = t.isOpen, o = t.resultCount, r = t.previousResultCount;
  return n ? o ? o !== r ? o + " result" + (o === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function St(t, n) {
  return t = Array.isArray(t) ? (
    /* istanbul ignore next (preact) */
    t[0]
  ) : t, !t && n ? n : t;
}
function en(t) {
  return typeof t.type == "string";
}
function tn(t) {
  return t.props;
}
function jn(t, n) {
  console.error('The property "' + n + '" is required in "' + t + '"');
}
var Wn = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function Ce(t) {
  t === void 0 && (t = {});
  var n = {};
  return Wn.forEach(function(o) {
    t.hasOwnProperty(o) && (n[o] = t[o]);
  }), n;
}
function Fn(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
var Un = ["refKey", "ref"], qn = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], Yn = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], zn = ["refKey", "ref"], Gn = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], Xn = /* @__PURE__ */ function() {
  var t = /* @__PURE__ */ function(n) {
    function o(i) {
      var e;
      e = n.call(this, i) || this, e.id = e.props.id || "downshift-" + Yt(), e.menuId = e.props.menuId || e.id + "-menu", e.labelId = e.props.labelId || e.id + "-label", e.inputId = e.props.inputId || e.id + "-input", e.getItemId = e.props.getItemId || function(s) {
        return e.id + "-item-" + s;
      }, e.items = [], e.itemCount = null, e.previousResultCount = 0, e.timeoutIds = [], e.internalSetTimeout = function(s, a) {
        var f = setTimeout(function() {
          e.timeoutIds = e.timeoutIds.filter(function(l) {
            return l !== f;
          }), s();
        }, a);
        e.timeoutIds.push(f);
      }, e.setItemCount = function(s) {
        e.itemCount = s;
      }, e.unsetItemCount = function() {
        e.itemCount = null;
      }, e.isItemDisabled = function(s, a) {
        var f = e.getItemNodeFromIndex(a);
        return f && f.hasAttribute("disabled");
      }, e.setHighlightedIndex = function(s, a) {
        s === void 0 && (s = e.props.defaultHighlightedIndex), a === void 0 && (a = {}), a = Ce(a), e.internalSetState(B({
          highlightedIndex: s
        }, a));
      }, e.clearSelection = function(s) {
        e.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: e.props.defaultHighlightedIndex,
          isOpen: e.props.defaultIsOpen
        }, s);
      }, e.selectItem = function(s, a, f) {
        a = Ce(a), e.internalSetState(B({
          isOpen: e.props.defaultIsOpen,
          highlightedIndex: e.props.defaultHighlightedIndex,
          selectedItem: s,
          inputValue: e.props.itemToString(s)
        }, a), f);
      }, e.selectItemAtIndex = function(s, a, f) {
        var l = e.items[s];
        l != null && e.selectItem(l, a, f);
      }, e.selectHighlightedItem = function(s, a) {
        return e.selectItemAtIndex(e.getState().highlightedIndex, s, a);
      }, e.internalSetState = function(s, a) {
        var f, l, b = {}, k = typeof s == "function";
        return !k && s.hasOwnProperty("inputValue") && e.props.onInputValueChange(s.inputValue, B({}, e.getStateAndHelpers(), s)), e.setState(function(C) {
          var j;
          C = e.getState(C);
          var H = k ? s(C) : s;
          H = e.props.stateReducer(C, H), f = H.hasOwnProperty("selectedItem");
          var $ = {};
          return f && H.selectedItem !== C.selectedItem && (l = H.selectedItem), (j = H).type || (j.type = Mt), Object.keys(H).forEach(function(W) {
            C[W] !== H[W] && (b[W] = H[W]), W !== "type" && (H[W], e.props[W] === void 0 && ($[W] = H[W]));
          }), k && H.hasOwnProperty("inputValue") && e.props.onInputValueChange(H.inputValue, B({}, e.getStateAndHelpers(), H)), $;
        }, function() {
          Dt(a)();
          var C = Object.keys(b).length > 1;
          C && e.props.onStateChange(b, e.getStateAndHelpers()), f && e.props.onSelect(s.selectedItem, e.getStateAndHelpers()), l !== void 0 && e.props.onChange(l, e.getStateAndHelpers()), e.props.onUserAction(b, e.getStateAndHelpers());
        });
      }, e.rootRef = function(s) {
        return e._rootNode = s;
      }, e.getRootProps = function(s, a) {
        var f, l = s === void 0 ? {} : s, b = l.refKey, k = b === void 0 ? "ref" : b, C = l.ref, j = se(l, Un), H = a === void 0 ? {} : a, $ = H.suppressRefError, W = $ === void 0 ? !1 : $;
        e.getRootProps.called = !0, e.getRootProps.refKey = k, e.getRootProps.suppressRefError = W;
        var z = e.getState(), T = z.isOpen;
        return B((f = {}, f[k] = me(C, e.rootRef), f.role = "combobox", f["aria-expanded"] = T, f["aria-haspopup"] = "listbox", f["aria-owns"] = T ? e.menuId : void 0, f["aria-labelledby"] = e.labelId, f), j);
      }, e.keyDownHandlers = {
        ArrowDown: function(a) {
          var f = this;
          if (a.preventDefault(), this.getState().isOpen) {
            var l = a.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(l, {
              type: Ne
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Ne
            }, function() {
              var b = f.getItemCount();
              if (b > 0) {
                var k = f.getState(), C = k.highlightedIndex, j = fe(C, 1, {
                  length: b
                }, f.isItemDisabled, !0);
                f.setHighlightedIndex(j, {
                  type: Ne
                });
              }
            });
        },
        ArrowUp: function(a) {
          var f = this;
          if (a.preventDefault(), this.getState().isOpen) {
            var l = a.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(l, {
              type: Te
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Te
            }, function() {
              var b = f.getItemCount();
              if (b > 0) {
                var k = f.getState(), C = k.highlightedIndex, j = fe(C, -1, {
                  length: b
                }, f.isItemDisabled, !0);
                f.setHighlightedIndex(j, {
                  type: Te
                });
              }
            });
        },
        Enter: function(a) {
          if (a.which !== 229) {
            var f = this.getState(), l = f.isOpen, b = f.highlightedIndex;
            if (l && b != null) {
              a.preventDefault();
              var k = this.items[b], C = this.getItemNodeFromIndex(b);
              if (k == null || C && C.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: At
              });
            }
          }
        },
        Escape: function(a) {
          a.preventDefault(), this.reset(B({
            type: Ht
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, e.buttonKeyDownHandlers = B({}, e.keyDownHandlers, {
        " ": function(a) {
          a.preventDefault(), this.toggleMenu({
            type: Wt
          });
        }
      }), e.inputKeyDownHandlers = B({}, e.keyDownHandlers, {
        Home: function(a) {
          var f = this.getState(), l = f.isOpen;
          if (l) {
            a.preventDefault();
            var b = this.getItemCount();
            if (!(b <= 0 || !l)) {
              var k = he(0, !1, {
                length: b
              }, this.isItemDisabled);
              this.setHighlightedIndex(k, {
                type: Bt
              });
            }
          }
        },
        End: function(a) {
          var f = this.getState(), l = f.isOpen;
          if (l) {
            a.preventDefault();
            var b = this.getItemCount();
            if (!(b <= 0 || !l)) {
              var k = he(b - 1, !0, {
                length: b
              }, this.isItemDisabled);
              this.setHighlightedIndex(k, {
                type: $t
              });
            }
          }
        }
      }), e.getToggleButtonProps = function(s) {
        var a = s === void 0 ? {} : s, f = a.onClick;
        a.onPress;
        var l = a.onKeyDown, b = a.onKeyUp, k = a.onBlur, C = se(a, qn), j = e.getState(), H = j.isOpen, $ = {
          onClick: J(f, e.buttonHandleClick),
          onKeyDown: J(l, e.buttonHandleKeyDown),
          onKeyUp: J(b, e.buttonHandleKeyUp),
          onBlur: J(k, e.buttonHandleBlur)
        }, W = C.disabled ? {} : $;
        return B({
          type: "button",
          role: "button",
          "aria-label": H ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, W, C);
      }, e.buttonHandleKeyUp = function(s) {
        s.preventDefault();
      }, e.buttonHandleKeyDown = function(s) {
        var a = Xe(s);
        e.buttonKeyDownHandlers[a] && e.buttonKeyDownHandlers[a].call(e, s);
      }, e.buttonHandleClick = function(s) {
        if (s.preventDefault(), e.props.environment) {
          var a = e.props.environment.document, f = a.body, l = a.activeElement;
          f && f === l && s.target.focus();
        }
        process.env.NODE_ENV === "test" ? e.toggleMenu({
          type: Ge
        }) : e.internalSetTimeout(function() {
          return e.toggleMenu({
            type: Ge
          });
        });
      }, e.buttonHandleBlur = function(s) {
        var a = s.target;
        e.internalSetTimeout(function() {
          if (!(e.isMouseDown || !e.props.environment)) {
            var f = e.props.environment.document.activeElement;
            (f == null || f.id !== e.inputId) && f !== a && e.reset({
              type: Ft
            });
          }
        });
      }, e.getLabelProps = function(s) {
        return B({
          htmlFor: e.inputId,
          id: e.labelId
        }, s);
      }, e.getInputProps = function(s) {
        var a = s === void 0 ? {} : s, f = a.onKeyDown, l = a.onBlur, b = a.onChange, k = a.onInput;
        a.onChangeText;
        var C = se(a, Yn), j, H = {};
        j = "onChange";
        var $ = e.getState(), W = $.inputValue, z = $.isOpen, T = $.highlightedIndex;
        if (!C.disabled) {
          var Z;
          H = (Z = {}, Z[j] = J(b, k, e.inputHandleChange), Z.onKeyDown = J(f, e.inputHandleKeyDown), Z.onBlur = J(l, e.inputHandleBlur), Z);
        }
        return B({
          "aria-autocomplete": "list",
          "aria-activedescendant": z && typeof T == "number" && T >= 0 ? e.getItemId(T) : void 0,
          "aria-controls": z ? e.menuId : void 0,
          "aria-labelledby": C && C["aria-label"] ? void 0 : e.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: W,
          id: e.inputId
        }, H, C);
      }, e.inputHandleKeyDown = function(s) {
        var a = Xe(s);
        a && e.inputKeyDownHandlers[a] && e.inputKeyDownHandlers[a].call(e, s);
      }, e.inputHandleChange = function(s) {
        e.internalSetState({
          type: jt,
          isOpen: !0,
          inputValue: s.target.value,
          highlightedIndex: e.props.defaultHighlightedIndex
        });
      }, e.inputHandleBlur = function() {
        e.internalSetTimeout(function() {
          var s;
          if (!(e.isMouseDown || !e.props.environment)) {
            var a = e.props.environment.document.activeElement, f = (a == null || (s = a.dataset) == null ? void 0 : s.toggle) && e._rootNode && e._rootNode.contains(a);
            f || e.reset({
              type: Lt
            });
          }
        });
      }, e.menuRef = function(s) {
        e._menuNode = s;
      }, e.getMenuProps = function(s, a) {
        var f, l = s === void 0 ? {} : s, b = l.refKey, k = b === void 0 ? "ref" : b, C = l.ref, j = se(l, zn), H = a === void 0 ? {} : a, $ = H.suppressRefError, W = $ === void 0 ? !1 : $;
        return e.getMenuProps.called = !0, e.getMenuProps.refKey = k, e.getMenuProps.suppressRefError = W, B((f = {}, f[k] = me(C, e.menuRef), f.role = "listbox", f["aria-labelledby"] = j && j["aria-label"] ? void 0 : e.labelId, f.id = e.menuId, f), j);
      }, e.getItemProps = function(s) {
        var a, f = s === void 0 ? {} : s, l = f.onMouseMove, b = f.onMouseDown, k = f.onClick;
        f.onPress;
        var C = f.index, j = f.item, H = j === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : jn("getItemProps", "item") : j, $ = se(f, Gn);
        C === void 0 ? (e.items.push(H), C = e.items.indexOf(H)) : e.items[C] = H;
        var W = "onClick", z = k, T = (a = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: J(l, function() {
            C !== e.getState().highlightedIndex && (e.setHighlightedIndex(C, {
              type: kt
            }), e.avoidScrolling = !0, e.internalSetTimeout(function() {
              return e.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: J(b, function(X) {
            X.preventDefault();
          })
        }, a[W] = J(z, function() {
          e.selectItemAtIndex(C, {
            type: Kt
          });
        }), a), Z = $.disabled ? {
          onMouseDown: T.onMouseDown
        } : T;
        return B({
          id: e.getItemId(C),
          role: "option",
          "aria-selected": e.getState().highlightedIndex === C
        }, Z, $);
      }, e.clearItems = function() {
        e.items = [];
      }, e.reset = function(s, a) {
        s === void 0 && (s = {}), s = Ce(s), e.internalSetState(function(f) {
          var l = f.selectedItem;
          return B({
            isOpen: e.props.defaultIsOpen,
            highlightedIndex: e.props.defaultHighlightedIndex,
            inputValue: e.props.itemToString(l)
          }, s);
        }, a);
      }, e.toggleMenu = function(s, a) {
        s === void 0 && (s = {}), s = Ce(s), e.internalSetState(function(f) {
          var l = f.isOpen;
          return B({
            isOpen: !l
          }, l && {
            highlightedIndex: e.props.defaultHighlightedIndex
          }, s);
        }, function() {
          var f = e.getState(), l = f.isOpen, b = f.highlightedIndex;
          l && e.getItemCount() > 0 && typeof b == "number" && e.setHighlightedIndex(b, s), Dt(a)();
        });
      }, e.openMenu = function(s) {
        e.internalSetState({
          isOpen: !0
        }, s);
      }, e.closeMenu = function(s) {
        e.internalSetState({
          isOpen: !1
        }, s);
      }, e.updateStatus = Be(function() {
        var s;
        if ((s = e.props) != null && (s = s.environment) != null && s.document) {
          var a = e.getState(), f = e.items[a.highlightedIndex], l = e.getItemCount(), b = e.props.getA11yStatusMessage(B({
            itemToString: e.props.itemToString,
            previousResultCount: e.previousResultCount,
            resultCount: l,
            highlightedItem: f
          }, a));
          e.previousResultCount = l, Jt(b, e.props.environment.document);
        }
      }, 200);
      var u = e.props, c = u.defaultHighlightedIndex, v = u.initialHighlightedIndex, d = v === void 0 ? c : v, I = u.defaultIsOpen, E = u.initialIsOpen, O = E === void 0 ? I : E, S = u.initialInputValue, M = S === void 0 ? "" : S, N = u.initialSelectedItem, K = N === void 0 ? null : N, L = e.getState({
        highlightedIndex: d,
        isOpen: O,
        inputValue: M,
        selectedItem: K
      });
      return L.selectedItem != null && e.props.initialInputValue === void 0 && (L.inputValue = e.props.itemToString(L.selectedItem)), e.state = L, e;
    }
    xn(o, n);
    var r = o.prototype;
    return r.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(e) {
        clearTimeout(e);
      }), this.timeoutIds = [];
    }, r.getState = function(e) {
      return e === void 0 && (e = this.state), Me(e, this.props);
    }, r.getItemCount = function() {
      var e = this.items.length;
      return this.itemCount != null ? e = this.itemCount : this.props.itemCount !== void 0 && (e = this.props.itemCount), e;
    }, r.getItemNodeFromIndex = function(e) {
      return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(e)) : null;
    }, r.scrollHighlightedItemIntoView = function() {
      {
        var e = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(e, this._menuNode);
      }
    }, r.moveHighlightedIndex = function(e, u) {
      var c = this.getItemCount(), v = this.getState(), d = v.highlightedIndex;
      if (c > 0) {
        var I = fe(d, e, {
          length: c
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(I, u);
      }
    }, r.getStateAndHelpers = function() {
      var e = this.getState(), u = e.highlightedIndex, c = e.inputValue, v = e.selectedItem, d = e.isOpen, I = this.props.itemToString, E = this.id, O = this.getRootProps, S = this.getToggleButtonProps, M = this.getLabelProps, N = this.getMenuProps, K = this.getInputProps, L = this.getItemProps, s = this.openMenu, a = this.closeMenu, f = this.toggleMenu, l = this.selectItem, b = this.selectItemAtIndex, k = this.selectHighlightedItem, C = this.setHighlightedIndex, j = this.clearSelection, H = this.clearItems, $ = this.reset, W = this.setItemCount, z = this.unsetItemCount, T = this.internalSetState;
      return {
        // prop getters
        getRootProps: O,
        getToggleButtonProps: S,
        getLabelProps: M,
        getMenuProps: N,
        getInputProps: K,
        getItemProps: L,
        // actions
        reset: $,
        openMenu: s,
        closeMenu: a,
        toggleMenu: f,
        selectItem: l,
        selectItemAtIndex: b,
        selectHighlightedItem: k,
        setHighlightedIndex: C,
        clearSelection: j,
        clearItems: H,
        setItemCount: W,
        unsetItemCount: z,
        setState: T,
        // props
        itemToString: I,
        // derived
        id: E,
        // state
        highlightedIndex: u,
        inputValue: c,
        isOpen: d,
        selectedItem: v
      };
    }, r.componentDidMount = function() {
      var e = this;
      if (process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && Ct(this._menuNode, this.getMenuProps), !this.props.environment)
        this.cleanup = function() {
          e.internalClearTimeouts();
        };
      else {
        var u = function() {
          e.isMouseDown = !0;
        }, c = function(S) {
          e.isMouseDown = !1;
          var M = Ve(S.target, [e._rootNode, e._menuNode], e.props.environment);
          !M && e.getState().isOpen && e.reset({
            type: Vt
          }, function() {
            return e.props.onOuterClick(e.getStateAndHelpers());
          });
        }, v = function() {
          e.isTouchMove = !1;
        }, d = function() {
          e.isTouchMove = !0;
        }, I = function(S) {
          var M = Ve(S.target, [e._rootNode, e._menuNode], e.props.environment, !1);
          !e.isTouchMove && !M && e.getState().isOpen && e.reset({
            type: qt
          }, function() {
            return e.props.onOuterClick(e.getStateAndHelpers());
          });
        }, E = this.props.environment;
        E.addEventListener("mousedown", u), E.addEventListener("mouseup", c), E.addEventListener("touchstart", v), E.addEventListener("touchmove", d), E.addEventListener("touchend", I), this.cleanup = function() {
          e.internalClearTimeouts(), e.updateStatus.cancel(), E.removeEventListener("mousedown", u), E.removeEventListener("mouseup", c), E.removeEventListener("touchstart", v), E.removeEventListener("touchmove", d), E.removeEventListener("touchend", I);
        };
      }
    }, r.shouldScroll = function(e, u) {
      var c = this.props.highlightedIndex === void 0 ? this.getState() : this.props, v = c.highlightedIndex, d = u.highlightedIndex === void 0 ? e : u, I = d.highlightedIndex, E = v && this.getState().isOpen && !e.isOpen, O = v !== I;
      return E || O;
    }, r.componentDidUpdate = function(e, u) {
      process.env.NODE_ENV !== "production" && (Qe(this.state, e, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && Ct(this._menuNode, this.getMenuProps)), this.props.selectedItem !== void 0 && this.props.selectedItemChanged(e.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: Ut,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(u, e) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, r.componentWillUnmount = function() {
      this.cleanup();
    }, r.render = function() {
      var e = St(this.props.children, Q);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var u = St(e(this.getStateAndHelpers()));
      if (!u)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && Jn(u, this.getRootProps), u;
      if (en(u))
        return /* @__PURE__ */ In(u, this.getRootProps(tn(u)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, o;
  }(En);
  return t.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: Ln,
    itemToString: function(o) {
      return o == null ? "" : (process.env.NODE_ENV !== "production" && Fn(o) && !o.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", o), String(o));
    },
    onStateChange: Q,
    onInputValueChange: Q,
    onUserAction: Q,
    onChange: Q,
    onSelect: Q,
    onOuterClick: Q,
    selectedItemChanged: function(o, r) {
      return o !== r;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? void 0 : window
    ),
    stateReducer: function(o, r) {
      return r;
    },
    suppressRefError: !1,
    scrollIntoView: Qt
  }, t.stateChangeTypes = Hn, t;
}();
process.env.NODE_ENV !== "production" && (Xn.propTypes = {
  children: h.func,
  defaultHighlightedIndex: h.number,
  defaultIsOpen: h.bool,
  initialHighlightedIndex: h.number,
  initialSelectedItem: h.any,
  initialInputValue: h.string,
  initialIsOpen: h.bool,
  getA11yStatusMessage: h.func,
  itemToString: h.func,
  onChange: h.func,
  onSelect: h.func,
  onStateChange: h.func,
  onInputValueChange: h.func,
  onUserAction: h.func,
  onOuterClick: h.func,
  selectedItemChanged: h.func,
  stateReducer: h.func,
  itemCount: h.number,
  id: h.string,
  environment: h.shape({
    addEventListener: h.func.isRequired,
    removeEventListener: h.func.isRequired,
    document: h.shape({
      createElement: h.func.isRequired,
      getElementById: h.func.isRequired,
      activeElement: h.any.isRequired,
      body: h.any.isRequired
    }).isRequired,
    Node: h.func.isRequired
  }),
  suppressRefError: h.bool,
  scrollIntoView: h.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: h.any,
  isOpen: h.bool,
  inputValue: h.string,
  highlightedIndex: h.number,
  labelId: h.string,
  inputId: h.string,
  menuId: h.string,
  getItemId: h.func
  /* eslint-enable react/no-unused-prop-types */
});
function Ct(t, n) {
  var o = n.refKey;
  t || console.error('downshift: The ref prop "' + o + '" from getMenuProps was not applied correctly on your menu element.');
}
function Jn(t, n) {
  var o = n.refKey, r = o !== "ref", i = !en(t);
  i && !r && !pt.isForwardRef(t) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !i && r && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + o + '"'), !pt.isForwardRef(t) && !tn(t)[o] && console.error('downshift: You must apply the ref prop "' + o + '" from getRootProps onto your root element.');
}
function Zn(t) {
  return "" + t.slice(0, 1).toUpperCase() + t.slice(1);
}
function Qn(t, n, o, r) {
  for (var i = t.type, e = {}, u = Object.keys(o), c = 0, v = u; c < v.length; c++) {
    var d = v[c];
    er(d, t, n, o, r), r[d] !== o[d] && (e[d] = r[d]);
  }
  typeof n.onStateChange == "function" && Object.keys(e).length && n.onStateChange(B({
    type: i
  }, e));
}
function er(t, n, o, r, i) {
  if (i[t] !== r[t]) {
    var e = "on" + Zn(t) + "Change", u = o[e];
    if (typeof u == "function") {
      var c = n.type;
      u(B({
        type: c
      }, i));
    }
  }
}
function tr(t, n, o, r) {
  var i = q.useRef({}), e = q.useCallback(function(S, M) {
    var N = S.state;
    N = Me(N, M.props);
    var K = t(N, M), L = M.props.stateReducer(N, B({}, M, {
      changes: K
    }));
    return {
      state: B({}, N, L),
      lastAction: M
    };
  }, [t]), u = q.useReducer(e, n, function(S) {
    return {
      state: o(S),
      lastAction: void 0
    };
  }), c = u[0], v = c.state, d = c.lastAction, I = u[1], E = Gt(n), O = q.useCallback(function(S) {
    return I(B({}, S, {
      props: E.current
    }));
  }, [E]);
  return q.useEffect(function() {
    if (d) {
      var S = Me(i.current, d.props), M = !r(S, v);
      M && Qn(d, d.props, S, v);
    }
    i.current = v;
  }, [v, d, r]), [v, O];
}
function nr(t, n, o, r) {
  var i = tr(t, n, o, r), e = i[0], u = i[1];
  return [Me(e, n), u];
}
function rr(t, n, o, r) {
  if (t !== void 0 && n !== void 0)
    return [t, n];
  if (t !== void 0) {
    var i = o.indexOf(t);
    if (i < 0)
      throw new Error(r);
    return [t, o.indexOf(t)];
  }
  if (n !== void 0) {
    var e = o[n];
    if (e === void 0)
      throw new Error(r);
    return [e, n];
  }
  throw new Error(r);
}
function nn() {
  var t = q.useRef(!0);
  return q.useEffect(function() {
    return t.current = !1, function() {
      t.current = !0;
    };
  }, []), t.current;
}
var or = {
  environment: h.shape({
    addEventListener: h.func.isRequired,
    removeEventListener: h.func.isRequired,
    document: h.shape({
      createElement: h.func.isRequired,
      getElementById: h.func.isRequired,
      activeElement: h.any.isRequired,
      body: h.any.isRequired
    }).isRequired,
    Node: h.func.isRequired
  }),
  itemToKey: h.func,
  stateReducer: h.func
};
function pe(t, n) {
  return t === void 0 ? n : t;
}
function ye(t, n, o, r) {
  return t !== void 0 ? t : n !== void 0 ? n : o !== void 0 ? o : r;
}
var Tt = Be(function(t, n) {
  Jt(t, n);
}, 200);
function ir(t, n, o, r) {
  var i = r == null ? void 0 : r.document, e = nn();
  q.useEffect(function() {
    if (!(!t || e || !i)) {
      var u = t(n);
      Tt(u, i);
    }
  }, o), q.useEffect(function() {
    return function() {
      Tt.cancel(), Kn(i);
    };
  }, [i]);
}
var Ie = B({}, or, {
  getA11yStatusMessage: h.func,
  highlightedIndex: h.number,
  defaultHighlightedIndex: h.number,
  initialHighlightedIndex: h.number,
  isOpen: h.bool,
  defaultIsOpen: h.bool,
  initialIsOpen: h.bool,
  selectedItem: h.any,
  initialSelectedItem: h.any,
  defaultSelectedItem: h.any,
  id: h.string,
  labelId: h.string,
  menuId: h.string,
  getItemId: h.func,
  toggleButtonId: h.string,
  onSelectedItemChange: h.func,
  onHighlightedIndexChange: h.func,
  onStateChange: h.func,
  onIsOpenChange: h.func,
  scrollIntoView: h.func
}), Re = {
  itemToString: function(n) {
    return n ? String(n) : "";
  },
  itemToKey: function(n) {
    return n;
  },
  isItemDisabled: function(n) {
    return !1;
  },
  stateReducer: function(n, o) {
    return o.changes;
  },
  scrollIntoView: Qt,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? void 0 : window
  )
}, re = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
}, ur = B({}, q), rn = ur.useId, sr = typeof rn == "function" ? ar : lr;
function ar(t) {
  var n = t.id, o = t.labelId, r = t.menuId, i = t.getItemId, e = t.toggleButtonId, u = t.inputId, c = "downshift-" + rn();
  n || (n = c);
  var v = q.useMemo(function() {
    return {
      labelId: o ?? n + "-label",
      menuId: r ?? n + "-menu",
      getItemId: i ?? function(d) {
        return n + "-item-" + d;
      },
      toggleButtonId: e ?? n + "-toggle-button",
      inputId: u ?? n + "-input"
    };
  }, [i, n, u, o, r, e]);
  return v;
}
function lr(t) {
  var n = t.id, o = t.labelId, r = t.menuId, i = t.getItemId, e = t.toggleButtonId, u = t.inputId, c = q.useState(function() {
    return n ?? "downshift-" + Yt();
  }), v = c[0], d = q.useMemo(function() {
    return {
      labelId: o ?? v + "-label",
      menuId: r ?? v + "-menu",
      getItemId: i ?? function(I) {
        return v + "-item-" + I;
      },
      toggleButtonId: e ?? v + "-toggle-button",
      inputId: u ?? v + "-input"
    };
  }, [i, u, o, r, e, v]);
  return d;
}
function on(t, n, o) {
  var r = pe(o, re.highlightedIndex);
  return t[r] && n(t[r], r) ? -1 : r;
}
function Nt(t, n, o, r, i, e) {
  var u = t.length && i >= 0;
  return B({
    isOpen: !1,
    highlightedIndex: -1
  }, u && B({
    selectedItem: t[i],
    isOpen: pe(o, re.isOpen),
    highlightedIndex: pe(r, re.highlightedIndex)
  }, e));
}
function ke(t, n, o, r, i, e, u, c) {
  return t.length === 0 ? -1 : n !== void 0 && u === n && (n === -1 || t[n] !== void 0 && !r(t[n], n)) ? n : o !== void 0 && (o === -1 || t[o] !== void 0 && !r(t[o], o)) ? o : e ? t.findIndex(function(v) {
    return i(e) === i(v);
  }) : c < 0 && t[t.length - 1] && !r(t[t.length - 1], t.length - 1) ? t.length - 1 : c > 0 && t[0] && !r(t[0], 0) ? 0 : -1;
}
function cr(t) {
  var n = ye(t.selectedItem, t.initialSelectedItem, t.defaultSelectedItem, re.selectedItem), o = ye(t.isOpen, t.initialIsOpen, t.defaultIsOpen, re.isOpen), r = dr(t), i = ye(t.inputValue, t.initialInputValue, t.defaultInputValue, re.inputValue);
  return {
    highlightedIndex: r < 0 && n && o ? t.items.findIndex(function(e) {
      return t.itemToKey(e) === t.itemToKey(n);
    }) : r,
    isOpen: o,
    selectedItem: n,
    inputValue: i
  };
}
function dr(t) {
  var n = ye(t.highlightedIndex, t.initialHighlightedIndex, t.defaultHighlightedIndex, re.highlightedIndex);
  return n > -1 && t.items[n] && t.isItemDisabled(t.items[n], n) ? -1 : n;
}
var un = Q;
process.env.NODE_ENV !== "production" && (un = function(n) {
  var o = n.props, r = n.state, i = q.useRef(o), e = nn();
  q.useEffect(function() {
    e || (Qe(r, i.current, o), i.current = o);
  }, [r, o, e]);
});
function fr(t, n, o) {
  var r = q.useRef({
    isMouseDown: !1,
    isTouchMove: !1,
    isTouchEnd: !1
  }), i = q.useCallback(function() {
    return o.map(function(e) {
      return e.current;
    });
  }, [o]);
  return q.useEffect(function() {
    if (!t)
      return Q;
    function e() {
      r.current.isTouchEnd = !1, r.current.isMouseDown = !0;
    }
    function u(I) {
      r.current.isMouseDown = !1, Ve(I.target, i(), t) || n();
    }
    function c() {
      r.current.isTouchEnd = !1, r.current.isTouchMove = !1;
    }
    function v() {
      r.current.isTouchMove = !0;
    }
    function d(I) {
      r.current.isTouchEnd = !0, !r.current.isTouchMove && !Ve(I.target, i(), t, !1) && n();
    }
    return t.addEventListener("mousedown", e), t.addEventListener("mouseup", u), t.addEventListener("touchstart", c), t.addEventListener("touchmove", v), t.addEventListener("touchend", d), function() {
      t.removeEventListener("mousedown", e), t.removeEventListener("mouseup", u), t.removeEventListener("touchstart", c), t.removeEventListener("touchmove", v), t.removeEventListener("touchend", d);
    };
  }, [t, i, n]), r;
}
var sn = function() {
  return Q;
};
process.env.NODE_ENV !== "production" && (sn = function() {
  for (var n = arguments.length, o = new Array(n), r = 0; r < n; r++)
    o[r] = arguments[r];
  var i = q.useRef(o.reduce(function(u, c) {
    return u[c] = {}, u;
  }, {}));
  q.useEffect(function() {
    Object.keys(i.current).forEach(function(u) {
      var c = i.current[u];
      if (!Object.keys(c).length) {
        console.error("downshift: You forgot to call the " + u + " getter function on your component / element.");
        return;
      }
      var v = c.suppressRefError, d = c.refKey, I = c.elementRef;
      v || I != null && I.current || console.error('downshift: The ref prop "' + d + '" from ' + u + " was not applied correctly on your element.");
    });
  }, []);
  var e = q.useCallback(function(u, c, v, d) {
    i.current[u] = {
      suppressRefError: c,
      refKey: v,
      elementRef: d
    };
  }, []);
  return e;
});
function pr(t, n, o, r, i, e) {
  var u = q.useRef(!0);
  return zt(function() {
    if (!(n < 0 || !o || !Object.keys(i.current).length))
      if (u.current) {
        var c = i.current[e(n)];
        c && r.current && t(c, r.current);
      } else
        u.current = !0;
  }, [n]), q.useCallback(function() {
    u.current = !1;
  }, []);
}
function gr(t, n) {
  return t.isOpen === n.isOpen && t.inputValue === n.inputValue && t.highlightedIndex === n.highlightedIndex && t.selectedItem === n.selectedItem;
}
function hr(t, n, o, r) {
  var i = o.type, e;
  switch (i) {
    case r.ItemMouseMove:
      e = {
        highlightedIndex: o.disabled ? -1 : o.index
      };
      break;
    case r.MenuMouseLeave:
      e = {
        highlightedIndex: -1
      };
      break;
    case r.ToggleButtonClick:
    case r.FunctionToggleMenu:
      e = {
        isOpen: !t.isOpen,
        highlightedIndex: t.isOpen ? -1 : ke(n.items, n.initialHighlightedIndex, n.defaultHighlightedIndex, n.isItemDisabled, n.itemToKey, t.selectedItem, t.highlightedIndex, 0)
      };
      break;
    case r.FunctionOpenMenu:
      e = {
        isOpen: !0,
        highlightedIndex: ke(n.items, n.initialHighlightedIndex, n.defaultHighlightedIndex, n.isItemDisabled, n.itemToKey, t.selectedItem, t.highlightedIndex, 0)
      };
      break;
    case r.FunctionCloseMenu:
      e = {
        isOpen: !1
      };
      break;
    case r.FunctionSetHighlightedIndex:
      {
        var u = o.highlightedIndex;
        e = {
          highlightedIndex: n.isItemDisabled(n.items[u], u) ? -1 : u
        };
      }
      break;
    case r.FunctionSetInputValue:
      e = {
        inputValue: o.inputValue
      };
      break;
    case r.FunctionReset:
      e = {
        highlightedIndex: on(n.items, n.isItemDisabled, n.defaultHighlightedIndex),
        isOpen: pe(n.defaultIsOpen, re.isOpen),
        selectedItem: pe(n.defaultSelectedItem, re.selectedItem),
        inputValue: pe(n.defaultInputValue, re.inputValue)
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return B({}, t, e);
}
var vr = B({}, Ie, {
  items: h.array.isRequired,
  isItemDisabled: h.func
});
function _r(t) {
  for (var n = t.keysSoFar, o = t.highlightedIndex, r = t.items, i = t.itemToString, e = t.isItemDisabled, u = n.toLowerCase(), c = 0; c < r.length; c++) {
    var v = (c + o + (n.length < 2 ? 1 : 0)) % r.length, d = r[v];
    if (d !== void 0 && i(d).toLowerCase().startsWith(u) && !e(d, v))
      return v;
  }
  return o;
}
var Pe = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 0, et = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_down__" : 1, tt = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_up__" : 2, He = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_character__" : 3, nt = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_escape__" : 4, rt = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_home__" : 5, ot = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_end__" : 6, it = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_enter__" : 7, ut = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_space_button__" : 8, st = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_up__" : 9, at = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_down__" : 10, Ae = process.env.NODE_ENV !== "production" ? "__togglebutton_blur__" : 11, an = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 12, ln = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 13, lt = process.env.NODE_ENV !== "production" ? "__item_click__" : 14, cn = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, dn = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, fn = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, pn = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, ct = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, Je = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, gn = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, hn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  FunctionCloseMenu: fn,
  FunctionOpenMenu: dn,
  FunctionReset: gn,
  FunctionSelectItem: ct,
  FunctionSetHighlightedIndex: pn,
  FunctionSetInputValue: Je,
  FunctionToggleMenu: cn,
  ItemClick: lt,
  ItemMouseMove: ln,
  MenuMouseLeave: an,
  ToggleButtonBlur: Ae,
  ToggleButtonClick: Pe,
  ToggleButtonKeyDownArrowDown: et,
  ToggleButtonKeyDownArrowUp: tt,
  ToggleButtonKeyDownCharacter: He,
  ToggleButtonKeyDownEnd: ot,
  ToggleButtonKeyDownEnter: it,
  ToggleButtonKeyDownEscape: nt,
  ToggleButtonKeyDownHome: rt,
  ToggleButtonKeyDownPageDown: at,
  ToggleButtonKeyDownPageUp: st,
  ToggleButtonKeyDownSpaceButton: ut
});
function mr(t, n) {
  var o = n.type, r = n.props, i;
  switch (o) {
    case lt:
      i = {
        isOpen: pe(r.defaultIsOpen, re.isOpen),
        highlightedIndex: on(r.items, r.isItemDisabled, r.defaultHighlightedIndex),
        selectedItem: r.items[n.index]
      };
      break;
    case He:
      {
        var e = n.key, u = "" + t.inputValue + e, c = !t.isOpen && t.selectedItem ? r.items.findIndex(function(S) {
          return r.itemToKey(S) === r.itemToKey(t.selectedItem);
        }) : t.highlightedIndex, v = _r({
          keysSoFar: u,
          highlightedIndex: c,
          items: r.items,
          itemToString: r.itemToString,
          isItemDisabled: r.isItemDisabled
        });
        i = {
          inputValue: u,
          highlightedIndex: v,
          isOpen: !0
        };
      }
      break;
    case et:
      {
        var d = n.altKey, I = t.isOpen ? fe(t.highlightedIndex, 1, r.items, r.isItemDisabled) : d && t.selectedItem == null ? -1 : ke(r.items, r.initialHighlightedIndex, r.defaultHighlightedIndex, r.isItemDisabled, r.itemToKey, t.selectedItem, t.highlightedIndex, 1);
        i = {
          highlightedIndex: I,
          isOpen: !0
        };
      }
      break;
    case tt:
      {
        var E = n.altKey;
        if (t.isOpen && E)
          i = Nt(r.items, r.itemToString, r.defaultIsOpen, r.defaultHighlightedIndex, t.highlightedIndex, !1);
        else {
          var O = t.isOpen ? fe(t.highlightedIndex, -1, r.items, r.isItemDisabled) : ke(r.items, r.initialHighlightedIndex, r.defaultHighlightedIndex, r.isItemDisabled, r.itemToKey, t.selectedItem, t.highlightedIndex, -1);
          i = {
            highlightedIndex: O,
            isOpen: !0
          };
        }
      }
      break;
    case it:
    case ut:
      i = Nt(r.items, r.itemToString, r.defaultIsOpen, r.defaultHighlightedIndex, t.highlightedIndex, !1);
      break;
    case rt:
      i = {
        highlightedIndex: he(0, !1, r.items, r.isItemDisabled),
        isOpen: !0
      };
      break;
    case ot:
      i = {
        highlightedIndex: he(r.items.length - 1, !0, r.items, r.isItemDisabled),
        isOpen: !0
      };
      break;
    case st:
      i = {
        highlightedIndex: fe(t.highlightedIndex, -10, r.items, r.isItemDisabled)
      };
      break;
    case at:
      i = {
        highlightedIndex: fe(t.highlightedIndex, 10, r.items, r.isItemDisabled)
      };
      break;
    case nt:
      i = {
        isOpen: !1,
        highlightedIndex: -1
      };
      break;
    case Ae:
      i = B({
        isOpen: !1,
        highlightedIndex: -1
      }, t.highlightedIndex >= 0 && r.items.length && {
        selectedItem: r.items[t.highlightedIndex]
      });
      break;
    case ct:
      i = {
        selectedItem: n.selectedItem
      };
      break;
    default:
      return hr(t, r, n, hn);
  }
  return B({}, t, i);
}
var yr = ["onClick"], Ir = ["onMouseLeave", "refKey", "ref", "aria-label"], Er = ["onBlur", "onClick", "onPress", "onKeyDown", "refKey", "ref"], br = ["item", "index", "onMouseMove", "onClick", "onMouseDown", "onPress", "refKey", "disabled", "ref"];
dt.stateChangeTypes = hn;
function dt(t) {
  t === void 0 && (t = {}), Zt(t, dt, vr);
  var n = B({}, Re, t), o = n.items, r = n.isItemDisabled, i = n.scrollIntoView, e = n.environment, u = n.getA11yStatusMessage, c = nr(mr, n, cr, gr), v = c[0], d = c[1], I = v.isOpen, E = v.highlightedIndex, O = v.selectedItem, S = v.inputValue, M = we(null), N = we(null), K = we({}), L = we(null), s = sr(n), a = Gt(v);
  ir(u, v, [I, E, O, S], e);
  var f = pr(i, E, I, N, K, s.getItemId);
  xe(function() {
    return L.current = Be(function(p) {
      p({
        type: Je,
        inputValue: ""
      });
    }, 500), function() {
      var p;
      (p = L.current) == null || p.cancel();
    };
  }, []), xe(function() {
    S && (L.current == null || L.current(d));
  }, [d, S]), un({
    props: n,
    state: v
  }), xe(function() {
    var p = ye(n.isOpen, n.initialIsOpen, n.defaultIsOpen, re.isOpen);
    p && M.current && M.current.focus();
  }, []);
  var l = te(function() {
    a.current.isOpen && d({
      type: Ae
    });
  }, [d, a]), b = ft(function() {
    return [N, M];
  }, []), k = fr(e, l, b), C = sn("getMenuProps", "getToggleButtonProps");
  xe(function() {
    I || (K.current = {});
  }, [I]);
  var j = ft(function() {
    return {
      ArrowDown: function(y) {
        y.preventDefault(), d({
          type: et,
          altKey: y.altKey
        });
      },
      ArrowUp: function(y) {
        y.preventDefault(), d({
          type: tt,
          altKey: y.altKey
        });
      },
      Home: function(y) {
        y.preventDefault(), d({
          type: rt
        });
      },
      End: function(y) {
        y.preventDefault(), d({
          type: ot
        });
      },
      Escape: function() {
        a.current.isOpen && d({
          type: nt
        });
      },
      Enter: function(y) {
        y.preventDefault(), d({
          type: a.current.isOpen ? it : Pe
        });
      },
      PageUp: function(y) {
        a.current.isOpen && (y.preventDefault(), d({
          type: st
        }));
      },
      PageDown: function(y) {
        a.current.isOpen && (y.preventDefault(), d({
          type: at
        }));
      },
      " ": function(y) {
        y.preventDefault();
        var _ = a.current;
        if (!_.isOpen) {
          d({
            type: Pe
          });
          return;
        }
        _.inputValue ? d({
          type: He,
          key: " "
        }) : d({
          type: ut
        });
      }
    };
  }, [d, a]), H = te(function(p) {
    var y = p ?? {}, _ = y.onClick, w = se(y, yr), R = function() {
      var x;
      (x = M.current) == null || x.focus();
    };
    return B({
      id: s.labelId,
      htmlFor: s.toggleButtonId,
      onClick: J(_, R)
    }, w);
  }, [s]), $ = te(function(p, y) {
    var _, w = p ?? {}, R = w.onMouseLeave, D = w.refKey, x = D === void 0 ? "ref" : D, P = w.ref, A = w["aria-label"], V = se(w, Ir), Y = y ?? {}, m = Y.suppressRefError, G = m === void 0 ? !1 : m, oe = function() {
      d({
        type: an
      });
    };
    return C("getMenuProps", G, x, N), B((_ = {}, _[x] = me(P, function(ue) {
      N.current = ue;
    }), _.id = s.menuId, _.role = "listbox", _["aria-label"] = A, _["aria-labelledby"] = A ? void 0 : "" + s.labelId, _.onMouseLeave = J(R, oe), _), V);
  }, [d, C, s]), W = te(function(p, y) {
    var _, w = p ?? {}, R = w.onBlur, D = w.onClick;
    w.onPress;
    var x = w.onKeyDown, P = w.refKey, A = P === void 0 ? "ref" : P, V = w.ref, Y = se(w, Er), m = y ?? {}, G = m.suppressRefError, oe = G === void 0 ? !1 : G, ue = function() {
      d({
        type: Pe
      });
    }, le = function() {
      a.current.isOpen && !k.current.isMouseDown && d({
        type: Ae
      });
    }, ve = function(be) {
      var ce = Xe(be);
      ce && ce in j ? j[ce](be) : /^\S{1}$/.test(ce) && d({
        type: He,
        key: ce
      });
    }, Ee = B((_ = {}, _[A] = me(V, function(ge) {
      M.current = ge;
    }), _["aria-activedescendant"] = I && E > -1 ? s.getItemId(E) : "", _["aria-controls"] = s.menuId, _["aria-expanded"] = I, _["aria-haspopup"] = "listbox", _["aria-labelledby"] = Y["aria-label"] ? void 0 : "" + s.labelId, _.id = s.toggleButtonId, _.role = "combobox", _.tabIndex = 0, _.onBlur = J(R, le), _), Y);
    return Y.disabled || Object.assign(Ee, {
      onClick: J(D, ue),
      onKeyDown: J(x, ve)
    }), C("getToggleButtonProps", oe, A, M), Ee;
  }, [d, s, I, E, k, C, j, a]), z = te(function(p) {
    var y, _ = p ?? {}, w = _.item, R = _.index, D = _.onMouseMove, x = _.onClick, P = _.onMouseDown;
    _.onPress;
    var A = _.refKey, V = A === void 0 ? "ref" : A, Y = _.disabled, m = _.ref, G = se(_, br);
    Y !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useSelect.');
    var oe = rr(w, R, o, "Pass either item or index to getItemProps!"), ue = oe[0], le = oe[1], ve = r(ue, le), Ee = function() {
      k.current.isTouchEnd || le === a.current.highlightedIndex || (f(), d({
        type: ln,
        index: le,
        disabled: ve
      }));
    }, ge = function() {
      d({
        type: lt,
        index: le
      });
    }, be = function(vn) {
      return vn.preventDefault();
    }, ce = B((y = {}, y[V] = me(m, function(_e) {
      _e && (K.current[s.getItemId(le)] = _e);
    }), y["aria-disabled"] = ve, y["aria-selected"] = ue === O, y.id = s.getItemId(le), y.role = "option", y.onMouseMove = J(D, Ee), y.onMouseDown = J(P, be), y), G);
    return ve || Object.assign(ce, {
      onClick: J(x, ge)
    }), ce;
  }, [o, r, O, s, k, f, d, a]), T = te(function() {
    d({
      type: cn
    });
  }, [d]), Z = te(function() {
    d({
      type: fn
    });
  }, [d]), X = te(function() {
    d({
      type: dn
    });
  }, [d]), ee = te(function(p) {
    d({
      type: pn,
      highlightedIndex: p
    });
  }, [d]), ie = te(function(p) {
    d({
      type: ct,
      selectedItem: p
    });
  }, [d]), ae = te(function() {
    d({
      type: gn
    });
  }, [d]), g = te(function(p) {
    d({
      type: Je,
      inputValue: p
    });
  }, [d]);
  return {
    // prop getters.
    getToggleButtonProps: W,
    getLabelProps: H,
    getMenuProps: $,
    getItemProps: z,
    // actions.
    toggleMenu: T,
    openMenu: X,
    closeMenu: Z,
    setHighlightedIndex: ee,
    selectItem: ie,
    reset: ae,
    setInputValue: g,
    // state.
    highlightedIndex: E,
    isOpen: I,
    selectedItem: O,
    inputValue: S
  };
}
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
B({}, Ie, {
  items: h.array.isRequired,
  isItemDisabled: h.func,
  inputValue: h.string,
  defaultInputValue: h.string,
  initialInputValue: h.string,
  inputId: h.string,
  onInputValueChange: h.func
});
Ie.stateReducer, Ie.itemToKey, Ie.environment, h.array, h.array, h.array, h.func, h.number, h.number, h.number, h.func, h.func, h.string, h.string;
Re.itemToKey, Re.stateReducer, Re.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var wr = B({}, q);
wr.useId;
h.func;
const xr = "320px", Or = "600px", Dr = "1025px", Sr = "_dropdown_g75u9_33", Cr = "_option_g75u9_37", Tr = "_label_g75u9_43", Nr = "_disabled_g75u9_46", Rr = "_trigger_g75u9_47", Pr = "_hiddenLabel_g75u9_56", Mr = "_list_g75u9_77", Vr = "_icon_g75u9_99", kr = "_selectedIcon_g75u9_109", Hr = "_popover_g75u9_117", Ar = "_isOpen_g75u9_120", ne = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: xr,
  "mobile-wide": "480px",
  tablet: Or,
  "tablet-wide": "800px",
  desktop: Dr,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  dropdown: Sr,
  option: Cr,
  label: Tr,
  disabled: Nr,
  trigger: Rr,
  hiddenLabel: Pr,
  list: Mr,
  icon: Vr,
  selectedIcon: kr,
  popover: Hr,
  isOpen: Ar,
  "size-s": "_size-s_g75u9_141"
}, qr = ({
  disabled: t,
  hiddenLabel: n = !1,
  label: o,
  maxItemsVisible: r,
  onValueChange: i,
  options: e,
  placeholder: u = "Select an option",
  size: c = "l",
  triggerText: v,
  value: d,
  ...I
}) => {
  o || console.warn("Dropdown component must provide a `label` attribute");
  const E = e.find((b) => b.value === d) ?? null, { getItemProps: O, getLabelProps: S, getMenuProps: M, getToggleButtonProps: N, highlightedIndex: K, isOpen: L } = dt({
    items: e,
    selectedItem: E,
    onSelectedItemChange: (b) => {
      b.selectedItem && i(b.selectedItem.value);
    }
  }), l = (r ? e.length > r : !1) && r && {
    "--max-list-height": `${32 * r}px`
  };
  return /* @__PURE__ */ $e(
    "div",
    {
      className: Ke(ne.dropdown, { [ne.disabled]: t }, ne[`size-${c}`]),
      "data-cxy-name": "dropdown",
      style: l || void 0,
      ...I,
      children: [
        /* @__PURE__ */ de(wn, { ...S(), className: Ke(ne.label, { [ne.hiddenLabel]: n }), size: c, children: o }),
        /* @__PURE__ */ $e(bn, { className: ne.trigger, variant: "ghost", ...N(), disabled: t, isFullWidth: !0, children: [
          /* @__PURE__ */ de("span", { "data-testid": "dropdown-label", children: v ?? (E ? E.label : u || "") }),
          /* @__PURE__ */ de("span", { className: ne.icon, "data-open": L, children: /* @__PURE__ */ de(_n, {}) })
        ] }),
        /* @__PURE__ */ de(
          "ul",
          {
            className: Ke(ne.list, ne.popover, {
              [ne.isOpen]: L
            }),
            ...M(),
            children: e.map((b, k) => /* @__PURE__ */ $e(
              "li",
              {
                className: ne.option,
                ...O({ index: k, item: b }),
                "data-highlighted": K === k,
                children: [
                  b.label,
                  (E == null ? void 0 : E.value) === b.value && /* @__PURE__ */ de("span", { className: ne.selectedIcon, children: /* @__PURE__ */ de(mn, {}) })
                ]
              },
              b.value
            ))
          }
        )
      ]
    }
  );
};
export {
  qr as Dropdown
};
